import { unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2290ada7"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "order_details"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text-large font-600 mr-3"
}, "订单记录", -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商品订单", -1));

const _hoisted_4 = {
  class: "content"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "旅行订单", -1));

const _hoisted_6 = {
  class: "content"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "酒店订单", -1));

const _hoisted_8 = {
  class: "content"
};
import { ArrowLeft } from '@element-plus/icons-vue';
import GoodsOrder from "@com/order/GoodsOrder.vue";
import TravelOrder from "@com/order/TravelOrder.vue";
import HotelOrder from "@com/order/HotelOrder.vue";
import { ref } from "vue";
import useRoute from "@util/router";
export default {
  __name: 'OrderDetails',

  setup(__props) {
    const route = useRoute();
    const activeName = ref("goods");

    function tabChange(val) {
      route.push({
        name: `member${val}order`,
        query: {
          login: route.query().login
        }
      });
    }

    function back() {
      route.push({
        name: 'membermanager'
      });
    }

    return (_ctx, _cache) => {
      const _component_el_page_header = _resolveComponent("el-page-header");

      const _component_el_header = _resolveComponent("el-header");

      const _component_el_badge = _resolveComponent("el-badge");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_header, null, {
          default: _withCtx(() => [_createVNode(_component_el_page_header, {
            onBack: back,
            icon: _unref(ArrowLeft)
          }, {
            title: _withCtx(() => [_createTextVNode(" 返回 ")]),
            content: _withCtx(() => [_hoisted_2]),
            _: 1
          }, 8, ["icon"])]),
          _: 1
        }), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeName.value = $event),
            onTabChange: tabChange,
            type: "border-card",
            class: "base_details_tabs"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              name: "goods"
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_3]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [activeName.value == 'goods' ? (_openBlock(), _createBlock(GoodsOrder, {
                key: 0,
                type: "member",
                routeName: "membergoodsorder"
              })) : _createCommentVNode("", true)])]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              name: "travel"
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_5]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [activeName.value == 'travel' ? (_openBlock(), _createBlock(TravelOrder, {
                key: 0,
                type: "member",
                routeName: "membertravelorder"
              })) : _createCommentVNode("", true)])]),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              name: "hotel"
            }, {
              label: _withCtx(() => [_createVNode(_component_el_badge, null, {
                default: _withCtx(() => [_hoisted_7]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [activeName.value == 'hotel' ? (_openBlock(), _createBlock(HotelOrder, {
                key: 0,
                type: "member",
                routeName: "memberhotelorder"
              })) : _createCommentVNode("", true)])]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};